import generateColor from "Common/componentUtils/generateColor";
export default (documentObject) => documentObject.Color || generateColor(documentObject.GroupName, 0.3);
